var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-sites"},_vm._l((_vm.userSites),function(item){return _c('div',{key:item.id,staticClass:"user-sites__item",on:{"click":function($event){return _vm.open(item.publicUrl)}}},[_c('iframe',{attrs:{"src":item.publicUrl,"frameborder":"0"}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }